<div class="dialog-slot-details-wrapper">
  <app-slot-details
    [slot]="data.slot"
    [visibleMetrics]="data.visibleMetrics"
    [showRawData]="data.showRawData || false"
    [showCloseButton]="false">
  </app-slot-details>
</div>

<div class="dialog-close-actions">
  <button mat-flat-button color="primary" (click)="onClose()" style="width: 100%; margin-top: 16px;">Close</button>
</div>
